import React, { useState } from "react";
import { apiService } from "../services/api";

interface LoginProps {
  onLoginSuccess: () => void;
}

export const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!password.trim()) {
      setError("Inserisci la password");
      return;
    }

    try {
      setLoading(true);
      setError("");
      const result = await apiService.login(password);
      if (result.success) {
        onLoginSuccess();
      } else {
        setError(result.error || "Password non valida");
      }
    } catch (err: any) {
      setError("Errore durante il login. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">⚡</div>
          <h2>VortexBot Dashboard</h2>
          <p>Inserisci la password di amministrazione per accedere</p>
        </div>

        {error && <div className="login-error-alert">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="dashboard-password">Password Dashboard</label>
            <input
              id="dashboard-password"
              type="password"
              placeholder="••••••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              disabled={loading}
              className="login-input"
            />
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Verifica in corso..." : "Accedi 🚀"}
          </button>
        </form>

        <div className="login-footer">
          <small>VortexBot Control Panel • Protetto con JWT HMAC</small>
        </div>
      </div>
    </div>
  );
};
